// extracted by mini-css-extract-plugin
module.exports = {"container":"part-cases-list_container__9DEJw"};